import Common from "./scripts/Common"
import MobileNavigation from "./scripts/MobileNavigation"
import ExampleReactComponent from "./scripts/ExampleReactComponent"
import TabComponent from "./scripts/TabComponent"
import TimelineComponent from "./scripts/TimelineComponent"
import React from "react"
import ReactDOM from "react-dom/client"
import FacilitySlider from "./scripts/FacilitySlider"
import SportFilter from "./scripts/SportFilter"
import SportModal from "./scripts/SportModal"
import FaqComponent from "./scripts/FaqComponent"
import DonationAmountSync from "./scripts/DonationAmountSync"



const mobileNavigation = new MobileNavigation()
const sportFilter = new SportFilter()
document.addEventListener("DOMContentLoaded", function () {
const donationAmountSync = new DonationAmountSync()
const sportModal = new SportModal()
const facilitySlider = new FacilitySlider()
const common = new Common()
})

const tabComponent = new TabComponent()
const timelineComponent = new TimelineComponent()
const faqComponent =new FaqComponent()


if (document.querySelector("#render-react-example-here")) {
  const root = ReactDOM.createRoot(document.querySelector("#render-react-example-here"))
  root.render(<ExampleReactComponent />)
}
